export default __webpack_public_path__ + "static/checknlearn-promo@1x-a985db8734c7fc72dba7bd5223a9fdc7.webp";